import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { debounce } from "lodash";
import Button from "../../components/Button";
import { Toolbar, ToolbarGroup } from "../../components/Toolbar";
import { emailsList, openModal } from "../../actions";

export class ListEmailToolbar extends Component {
  constructor(props) {
    super(props);
    this.openCreateModal = this.openCreateModal.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.search = debounce(this.search.bind(this), 300);
    this.searchRef = createRef();
  }

  componentDidMount() {
    if (this.searchRef?.current) {
      this.searchRef.current.focus();
    }
  }

  onSearch(e) {
    const searchTerm = e.currentTarget.value;
    this.search(searchTerm);
  }

  search(searchTerm) {
    this.props.emailsList(
      this.props.accountId,
      {
        name: searchTerm,
      },
      true
    );
  }

  openCreateModal() {
    const { accountId } = this.props;

    this.props.openModal("create-email", {
      accountId,
    });
  }

  render() {
    return (
      <Toolbar>
        <ToolbarGroup>
          <input
            ref={this.searchRef}
            placeholder="Search"
            style={{ width: "100%" }}
            onChange={this.onSearch}
          />
        </ToolbarGroup>

        <ToolbarGroup width="160px" align="right">
          <Button onClick={this.openCreateModal}>Create Email</Button>
        </ToolbarGroup>
      </Toolbar>
    );
  }
}

ListEmailToolbar.propTypes = {
  openModal: PropTypes.func.isRequired,
};

// Connect actions
export default connect(null, {
  emailsList,
  openModal,
})(ListEmailToolbar);
